export default {
  en: {    
  	login: {
        email: 'Email',
        password: 'Password',
        forgotpassword: 'Forgot Password?',
        error:' Woops, something went wrong!',
        register: 'Don\'t have an account?',
        signup: 'Sign up',
        returntologin: 'Return to login',
        resetdisclaimer: 'Fill in your email below and we\'ll send you a password reset link.',
        resetbutton: 'Send email',
        confirmemail: 'You have to confirm your e-mailadress before you can create a shipment! Contact us if you did not receive the confirmation e-mail.'
  	}  	  	  	
  },
  nl: {    
  	login: {
        email: 'E-mail',
        password: 'Wachtwoord',
        forgotpassword: 'Wachtwoord vergeten?',
        register: 'Nog geen account?',
        error:' Er ging iets mis!',
        signup: 'Registreer hier',
        returntologin: 'Terug naar login',
        resetdisclaimer: 'Vul je e-mailadres in en we sturen je een link waarmee je een nieuw wachtwoord kan instellen.',
        resetbutton: 'Stuur e-mail',
        confirmemail: 'U moet uw e-mailadres bevestigen voor u een zending kan aanmaken! Contacteer ons als je de bevestigingsmail niet hebt ontvangen.'  		
  	}  	
  },
  fr: {    
  	login: {
        email: 'Email',
        password: 'Mot de passe',
        error:' Quelque chose a mal tourné!',
        forgotpassword: 'Oublié mot de passe?',
        register: 'Pas encore de compte?',
        signup: 'Inscrivez-vous ici',
        returntologin: 'Retourner à la connexion',
        resetdisclaimer: 'Entrez votre adresse e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
        resetbutton: 'Envoyer e-mail',
        confirmemail: 'Vous devez confirmer votre adresse e-mail avant de créer un envoi! Contacter-nous si vous n’avez pas reçu l’e-mail de confirmation.'
  	}  	
  }
}